import { FormObjType } from "DataTypes/Form";

export const ContactForm: FormObjType[] = [
  {
    id: "firstName",
    label: "First Name",
    placeholder: "Enter First Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "middleName",
    label: "Middle Name",
    placeholder: "Enter Middle Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name",
    enableFormLoad: true,
  },
  {
    id: "lastName",
    label: "Last Name",
    placeholder: "Enter Last Name",
    boxType: "input",
    boxSize: 3,
    validatetype: "name",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "relationToPatient",
    label: "Relation with patient",
    placeholder: "Enter your relation with patient",
    boxType: "input",
    boxSize: 3,
    validatetype: "alphanumericName",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "email",
    label: "Email ID",
    placeholder: "Enter Email ID",
    boxType: "input",
    boxSize: 3,
    validatetype: "email",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactStreetAddress",
    label: "Street Address",
    placeholder: "Enter Street Address",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactAddressCity",
    label: "City",
    placeholder: "Enter City",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactAddressState",
    label: "State",
    placeholder: "Enter State",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactAddressZip",
    label: "Zip Code",
    placeholder: "Enter Zip Code",
    boxType: "input",
    boxSize: 3,
    validatetype: "zipcode",
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactAddressCountry",
    label: "Country",
    placeholder: "Enter Country",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactPhoneNumberHome",
    label: "Phone Number",
    placeholder: "Enter Phone Number",
    boxType: "input",
    boxSize: 3,
    validatetype: "mobile no.",
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactPhoneNumberOffice",
    label: "Office Number",
    placeholder: "Enter Office Number",
    boxType: "input",
    boxSize: 3,
    validatetype: "mobile no.",
    enableFormLoad: true,
  },
  {
    id: "patientAdminContactPhoneNumberMobile",
    label: "Mobile Number",
    placeholder: "Enter Mobile Number",
    boxType: "input",
    boxSize: 3,
    validatetype: "mobile no.",
    enableFormLoad: true,
  },
]